
<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    @new-confirm-and-add-other-action="createEntry(true)"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  // mounted(){
  //   if(this.entry.tablePriceIds){
  //     this.entry.tablePriceIds = [];
  //   }
  // },
  // created() {
  //   if(this.entry.tablePriceIds){
  //     this.entry.tablePriceIds = [];
  //   }
  // },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_TABLE_PRICE_ITEM_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.tablePriceItem;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(tablePriceItem, saveAndAddOther) {
      // console.log("SUBCULTURE", tablePriceItem, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(tablePriceItem, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_TABLE_PRICE_ITEM_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(tablePriceItem, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createTablePriceItem.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createTablePriceItem.tablePriceItem);
            if (saveAndAddOther) {
              this.loadServerEntry();
              this.$refs.baseNew.newDialog = true;
            }
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function(saveAndAddOther=false) {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry, saveAndAddOther);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_TABLE_PRICE_ITEM_QUERY = gql `
  {
    accountContext{
      tablePriceItem {
        description
        percent
        percentType
        paymentConditionRuleIdsAttribute
        tablePriceIdsAttribute
        itemIdsAttribute
        commission
        discountAddition
        validations
      }
      allPaymentConditionRules{
        id
        description
      }
      allTablePrices{
        id
        description
      }
      percentTypes
    }
    accountGlobalSharedContext {
      allBrandsOfItems {
        id
        name
      }
    }
  }
`;

const CREATE_TABLE_PRICE_ITEM_MUTATION = gql `
  mutation($input: TablePriceItemCreateInputObject!) {
    createTablePriceItem(input: $input) {
      tablePriceItem {  
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

